
var scrollLess = {};
import genaration from '../../utils/classname';
export var scrollClass = genaration(scrollLess, 'scroll');